import Image from 'app/Components/Shared/Image/image';
import React, { useEffect } from 'react';
import Config from '../../../../Config';
import EpiContext from '@episerver/spa-core/Spa';
import RedirectButton from '../RedirectButton/RedirectButton';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import { useDispatch } from 'react-redux';
import { setPhoneListData } from '../../EsimGeneralBlock/esimBlockSlice';
import { prepareUrl } from '../../../../utilities/StringHelpers/StringHelpers';
import { Row, Col } from 'reactstrap';
import { functions } from 'lodash';

const InstallSuccess = (props) => {
  const dispatch = useDispatch();

  const socType =
    props.contentData?.privateSocsList?.value !== null || props.contentData?.privateSocsList?.value !== undefined
      ? props.contentData?.privateSocsList?.value
      : null;

  const esimInstallationLink = () => {
    let url = props.contentData.esimData.expandedValue[0]?.esimInstallationUrl?.value;
    prepareUrl(url, EpiContext);
  };

  useEffect(() => {
    if (props.phoneData?.payload?.Body?.data !== undefined && props.phoneData?.payload?.Body?.data !== null) {
      sendDataListToStore();
    }
  }, [props.phoneData]);

  const sendDataListToStore = () => {
    var phoneListData = {
      id: props.phoneData.payload.Body.data[0]?.id,
      phoneNumber: props.phoneData.payload.Body.data[0].phoneNumber,
      statusInstall: props.phoneData.payload.Body.data[0].statusInstall,
      qrCodeData: {
        smdp: props.phoneData.payload.Body.data[0].qrCodeData.smdp,
        accessCode: props.phoneData.payload.Body.data[0].qrCodeData.accessCode,
        base64Image: props.phoneData.payload.Body.data[0].qrCodeData.base64Image,
      },
      stickerNumber: props.phoneData.payload.Body.data[0].stickerNumber,
    };
    dispatch(setPhoneListData([phoneListData]));
  };

  return (
    <div className='install-success'>
      {socType[0] == 'UpgradeEsimAction' ? <Image src={require('../images/icon-esim.svg')} alt='esim-icon' /> : <Image src={require('../images/icon-120-like.svg')} alt='light-icon' />}
      <label className='title'>{props.contentData?.privateSuccessText?.value}</label>

      {
        props.isPrivateUser ? (
          <>
            {props.contentData?.privateSuccessSubText?.value && <label className='sub-title' dangerouslySetInnerHTML={{ __html: props.contentData?.privateSuccessSubText?.value }}></label>}
          </>
        ) : (
          <>
            {props.contentData?.businessSuccessSubText?.value && <label className='sub-title' dangerouslySetInnerHTML={{ __html: props.contentData?.businessSuccessSubText?.value }}></label>}
          </>
        )
      }

      {props.isShowOtherSubscribersLink && (
        <RedirectButton titleText='לרכישת השרות למנוי נוסף' onClick={props.onClickOtherSubscribersLink} />
      )}
      {props.isShowMoreServicesLink && <RedirectButton titleText='למגוון שירותים נוספים' onClick={props.onClickMoreServicesLink} />}
      {socType[0] == 'UpgradeEsimAction' ? (
        <>
          <div className='serviceContainer'>
            <Row xs='2'>
              <Col className='serviceNumberContainer'>
                <div className='phoneItem'>
                  <span className='phoneIcon'>
                    <Image src={require('../images/icon-24-cellular-black.svg')} alt='light-icon' />
                  </span>
                  <span className='phoneNumberText'>{props.phoneNumber}</span>
                </div>
              </Col>
            </Row>
          </div>
          <div className='serviceContent'>
            <div className='itemContainer'>
              <span className='lightIcon'>
                <Image src={require('../images/icon-24-light.svg')} alt='light-icon' />
              </span>
              <div>
                <span className='titleItem'>כיצד מפעילים?</span>
                <br />
                <span className='textItem'>{props.contentData.instructionsChangeSimToEsimText.value}</span>
              </div>
            </div>
          </div>
          <BtnSubmit text='להפעלת ה-eSIM' onclick={() => esimInstallationLink()} />
        </>
      ) : (
        <BtnSubmit text='סיום' onclick={() => handleOnFinish()} />
      )}
    </div>
  );

  function handleOnFinish() {
    var storage = window.localStorage || window.sessionStorage;
    const returnUrl = storage.getItem("returnUrl");
    storage.removeItem('returnUrl');
    //EpiContext.navigateTo(returnUrl ? returnUrl : Config.lobbyUrl);
    window.location.href = (returnUrl ? returnUrl : Config.lobbyUrl);
  }

};

export default InstallSuccess;
